<template>
  <TsRow class="my-4 gap-2 overflow-auto hide-scroll-bar">
    <template v-for="(tag, index) in props.tags" :key="tag">
      <NuxtLinkWithLocale
          v-if="tag.link"
          :to="tag.link"
          :data-testid="`${props.dataTestId}-tag-link-${index}`"
      >
        <TsTag
            size="lg"
            :label="tag.name"
            rounded
            :data-testid="`${props.dataTestId}-tag-${index}`"
            @click="emit('select', tag)"
            class="cursor-pointer"
            :class="{'bg-primary text-white' : active === tag.value}"
        >
          {{ tag.name }}
        </TsTag>
      </NuxtLinkWithLocale>
      <button
          v-else
          :data-testid="`${props.dataTestId}-tag-link-${index}`"
      >
        <TsTag
            size="lg"
            :label="tag.name"
            rounded
            :data-testid="`${props.dataTestId}-tag-${index}`"
            @click="emit('select', tag)"
            class="cursor-pointer"
            :class="{'bg-primary text-white' : active === tag.value}"
        >
          {{ tag.name }}
        </TsTag>
      </button>
    </template>
  </TsRow>
</template>

<script setup lang="ts">
import {useRandomUUID} from "~/composables/useRandomUUID";
import {onMounted, ref} from "vue";


const random_id = ref("");

const emit = defineEmits(['select'])

onMounted(() => {
  random_id.value = useRandomUUID();
});

type Props = {
  tags?: object;
  active: string;
  dataTestid?: string;
}

const props = defineProps<Props>();

</script>
